/**
 * Terminal usage keys (card e1b83600): which shell a tab or split opened, which
 * coding-agent profile launched, splits, and the MCP-approved AI tab. Keys from
 * the closed `TERMINAL` set only — never a command, a path or a host.
 *
 * A pane with no `shellKey` gets the platform default, which Rust picks as the
 * FIRST entry of `terminal_list_shells` (cmd on Windows, `$SHELL` elsewhere),
 * so that is what is counted for it.
 */
import { invoke } from '@tauri-apps/api/core';
import { recordFeature, TERMINAL, terminalShellKeyFor, terminalAgentKeyFor } from './index';

let defaultShell = null;

async function resolveShell(shellKey) {
  if (shellKey) return shellKey;
  if (defaultShell) return defaultShell;
  try {
    const shells = await invoke('terminal_list_shells');
    defaultShell = (Array.isArray(shells) && shells[0]?.key) || null;
  } catch {
    // no shell list (web build, tests): count nothing rather than guess
  }
  return defaultShell;
}

/** A pane was opened from `spec` ({ kind, shellKey, ai }). */
export function recordTerminalPane(spec) {
  try {
    if (!spec) return;
    if (spec.kind === 'ssh') {
      recordFeature(spec.ai ? TERMINAL.AI_TAB : TERMINAL.SHELL_SSH);
      return;
    }
    if (spec.kind === 'local') {
      resolveShell(spec.shellKey).then((key) => { if (key) recordFeature(terminalShellKeyFor(key)); });
    }
  } catch {
    // counting must never break opening a terminal
  }
}

export const recordTerminalSplit = () => recordFeature(TERMINAL.SPLIT);

/** An agent profile launched (`terminalProfiles.js` id; anything else is custom). */
export const recordTerminalAgent = (profileId) => recordFeature(terminalAgentKeyFor(profileId));

/** Tests only. */
export function __resetTerminalUsageForTests() {
  defaultShell = null;
}
